import { NgModule } from '@angular/core';

import { COWTUXCountdownComponent } from '@cowtux/components/countdown/countdown.component';

@NgModule({
    declarations: [
        COWTUXCountdownComponent
    ],
    exports: [
        COWTUXCountdownComponent
    ],
})
export class COWTUXCountdownModule
{
}
